import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Types from '../components/Types';
var OPEN_BRACE = '{';
var CLOSE_BRACE = '}';

var ReturnItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReturnItem, _React$Component);

  function ReturnItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ReturnItem.prototype;

  _proto.render = function render() {
    var data = this.props.data;

    if (data) {
      var types = data.types,
          description = data.description;
      var desc = description ? " - " + description : '';
      return React.createElement("div", {
        className: "returns"
      }, React.createElement("h5", {
        className: "title"
      }, "RETURNS:"), React.createElement("span", {
        className: "description"
      }, OPEN_BRACE, " ", React.createElement(Types, {
        data: types
      }), " ", CLOSE_BRACE, desc));
    }

    return null;
  };

  return ReturnItem;
}(React.Component);

export default ReturnItem;